import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import Button from 'components/button';

import { useVerifyByOtpMutation, useResendEmailOTPMutation } from 'api/authAPI';
import { showAlert } from 'features/modal/modal';

import { useDispatch } from 'react-redux';
import { handleError, removeState } from 'utils';
import { useLogoutMutation } from 'api/authAPI';
import { logoutReducer } from 'features/auth/authSlice';
import OtpInput from 'components/form/OtpField';

const OtpForm = () => {
	const dispatch = useDispatch();
	const schema = yup.object().shape({
		two_factor_code: yup.string().required('this field is required')
	});

	const [resendEmailOTP] = useResendEmailOTPMutation();
	const [logout] = useLogoutMutation();

	const [verifyByOtp] = useVerifyByOtpMutation();
	const [disableLogin, setDisableLogin] = useState(false);
	const {
		control,
		handleSubmit,
		setError,
		formState: { errors }
	} = useForm({
		resolver: yupResolver(schema),

		defaultValues: {
			two_factor_code: ''
		}
	});

	const reSendOtp = () => {
		resendEmailOTP()
			.unwrap()
			.then(res => {
				console.log(res);
				setDisableLogin(false);
				setError('apiError', '');
			})
			.catch(err => {
				dispatch(
					showAlert({
						type: 'error',
						title: 'Error',
						content: handleError(err)
					})
				);
			});
	};

	const onSubmit = data => {
		verifyByOtp({ two_factor_code: Number(data.two_factor_code) })
			.unwrap()
			.then(res => {
				console.log(res);
				setDisableLogin(false);
			})
			.catch(err => {
				console.log(err);
				if (err.status === 'PARSING_ERROR') {
					localStorage.clear();
					sessionStorage.clear();
					window.location.reload();
				} else if (err.status === 426) {
					setError('apiError', { message: err?.data?.message });
					setDisableLogin(true);
				} else {
					setError('apiError', { message: err?.data?.message });
					setDisableLogin(false);
				}
			});
	};

	const handleLogOut = () => {
		logout()
			.unwrap()
			.then(res => {
				if (res.message) {
					dispatch(logoutReducer());
				}
			});
		removeState('cayesh_user_loggged');
		window.location.reload();
	};
	return (
		<form onSubmit={handleSubmit(onSubmit)} className='d-flex flex-column w-100'>
			<Controller
				name='two_factor_code'
				control={control}
				rules={{ required: true }}
				render={({ field: { onChange, onBlur, value, name }, fieldState: { invalid, error } }) => (
					<>
						<label className='d-flex flex-column'>
							<span className=''>Please enter the received OTP</span>{' '}
						</label>
						<OtpInput
							placeholder='Enter OTP'
							name={name}
							onChange={onChange}
							value={value}
							invalid={invalid || errors.apiError ? invalid || errors.apiError?.message : undefined}
							error={error || errors.apiError}
							disabled={disableLogin}
							control={control}
							onBlur={onBlur} // notify when input is touched
						/>
					</>
				)}
			/>
			<div className='d-flex flex-column justify-content-between'>
				<div className='d-flex flex-row'>
					<span>Didn’t recieve an OTP code?</span>
					<a role='button' className='text-decoration-underline px-2' onClick={() => reSendOtp()}>
						Resend
					</a>
				</div>
				<Button type='submit' className='btn btn-primary w-100 mt-4'>
					Login
				</Button>

				<Button className='btn btn-link w-100 mt-4' onClick={handleLogOut}>
					Use another account
				</Button>
			</div>
		</form>
	);
};

export default OtpForm;
